import { server_connection } from 'config';

export const GET_USER_NOTE_LIST       = '[USER NOTE] GET USER NOTE LIST';
export const UPDATE_USER_NOTE_DETAIL  = '[USER NOTE] UPDATE USER NOTE DETAIL';
export const SET_CURRENT_NOTE_TEXT    = '[USER NOTE] SET CURRENT NOTE TEXT';
export const UPDATE_CURRENT_NOTE_TEXT = '[USER NOTE] UPDATE CURRENT NOTE TEXT';
export const HIDE_TAB                 = '[USER NOTE] HIDE TAB';
export const EDIT_TAB                 = '[USER NOTE] EDIT TAB';
export const UPDATE_TAB_NAME          = '[USER NOTE] UPDATE TAB NAME';
export const SET_ACTIVE_TAB           = '[USER NOTE] SET ACTIVE TAB';
export const ADD_NEW_TAB              = '[USER NOTE] ADD NEW TAB';
export const SET_CURRENT_TAB          = '[USER NOTE] SET CURRENT TAB';
export const EDIT_TAB_NAME            = '[USER NOTE] EDIT TAB NAME';
export const DELETE_USER_NOTE_ASSET   = '[USER NOTE] DELETE USER NOTE ASSET';
export const RE_PULL_USER_NOTE_DETAIL_ASSETS = '[USER NOTE] RE PULL USER NOTE DETAIL ASSETS';

export function getUserNoteList(auth_id) {
    return (dispatch) => {
        fetch(server_connection + '/note/user/list',
            {
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json'
                },
                method: 'POST',
                body: JSON.stringify({ auth_id })
            })
            .then((response) => response.json())
            .then((responseData) => {
                dispatch({
                    type: GET_USER_NOTE_LIST,
                    payload: responseData
                })
            });
    }
}

export function saveUserNoteDetail(user_note_detail_id, user_note_id, note_text, chapter_name) {
    return (dispatch) => {
        fetch(server_connection + '/note/user/save_detail',
            {
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json'
                },
                method: 'POST',
                body: JSON.stringify({ user_note_detail_id, user_note_id, note_text, chapter_name })
            })
            .then((response) => response.json())
            .then((responseData) => {
            })
    }
}

export function deleteUserNoteDetail(auth_id, user_note_detail_id) {
    return (dispatch) => {
        fetch(server_connection + '/note/user/delete_detail',
            {
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json'
                },
                method: 'POST',
                body: JSON.stringify({ user_note_detail_id })
            })
            .then((response) => response.json())
            .then((responseData) => {
                dispatch(getUserNoteList(auth_id));
            });
    }
}

export function updateUserNoteDetail(user_note_detail_id, note_text) {
    return (dispatch) => {
        dispatch({
            type: UPDATE_USER_NOTE_DETAIL,
            payload: { user_note_detail_id, note_text }
        });
    }
}

export function setCurrentNoteText(note_text, user_note_detail_id) {
    return (dispatch) => {
        dispatch({
            type: SET_CURRENT_NOTE_TEXT,
            payload: { note_text, user_note_detail_id }
        });
    }
}

export function updateCurrentNoteText(note_text) {
    return (dispatch) => {
        dispatch({
            type: UPDATE_CURRENT_NOTE_TEXT,
            payload: note_text
        });
    }
}

export function updateTabName(tab_name, user_note_detail_id) {
    return (dispatch) => {
        dispatch({
            type: UPDATE_TAB_NAME,
            payload: { tab_name, user_note_detail_id }
        });
    }
}

export function setActiveTab(user_note_detail_id, active_value) {
    return (dispatch) => {
        fetch(server_connection + '/note/user/set_active',
            {
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json'
                },
                method: 'POST',
                body: JSON.stringify({
                    user_note_detail_id: user_note_detail_id,
                    active_value:        active_value,
                })
            })
            .then((response) => response.json())
            .then((responseData) => {
                dispatch({
                    type: SET_ACTIVE_TAB,
                    payload: { user_note_detail_id, active_value },
                });
            });
    }
}

export function addTab(auth_id, user_note_id, chapter_name) {
    return (dispatch) => {
        fetch(server_connection + '/note/user/save_detail',
            {
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json'
                },
                method: 'POST',
                body: JSON.stringify({ 
                    user_note_detail_id: 0, 
                    user_note_id:        user_note_id, 
                    note_text:           '', 
                    chapter_name:        chapter_name,
                })
            })
            .then((response) => response.json())
            .then((responseData) => {
                dispatch(getUserNoteList(auth_id));
            });
    }
}

export function setCurrentTab(current_tab) {
    return (dispatch) => {
        dispatch({
            type: SET_CURRENT_TAB,
            payload: current_tab
        });
    }
}

export function editTabName(tab_name) {
    return (dispatch) => {
        dispatch({
            type: EDIT_TAB_NAME,
            payload: tab_name
        });
    }
}

export function deleteUserNoteAsset(asset_id, user_note_detail_id) {
    return async (dispatch, getState) => {
        await fetch(server_connection + '/note/user/delete_asset/' + asset_id)
            // .then((response) => response.json())
            .then(() => {
                rePullUserNoteDetailAssets(user_note_detail_id)
            })
            
    }
}

export function rePullUserNoteDetailAssets(user_note_detail_id) {
    return async (dispatch, getState) => {
        await fetch(server_connection + '/note/user/pull_assets/' + user_note_detail_id)
            .then((response) => response.json())
            .then((data) => {
                dispatch({
                    type: RE_PULL_USER_NOTE_DETAIL_ASSETS,
                    payload: {data, user_note_detail_id}
                })
            })
    }
}


// WEBPACK FOOTER //
// src/main/components/note/store/actions/user_note.actions.js